
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/payment-initiation/reconciliation",
      function () {
        return require("private-next-pages/docs/payment-initiation/reconciliation.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/payment-initiation/reconciliation"])
      });
    }
  